module.exports = __webpack_public_path__ + "img/ib-chemistry-text.b083f169.svg";